/**
 * TanStack Router: /vacation
 *
 * This route file was auto-generated by the route generation script.
 * Component: VacationPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import VacationPage from '@/app/vacation/page'

/**
 * Route: /vacation
 * Layout: _auth (authenticated)
 * Component: VacationPage
 */
export const Route = createFileRoute('/_auth/vacation/')({
  component: VacationPage,
})
